"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updater = void 0;
var common_1 = require("../connectors/common");
var logger_1 = require("./logger");
var updater = function updater(connector, dispatch) {
  var logger = (0, logger_1.getApplicationLogger)();
  connector.on(common_1.ConnectorEvents.ADDRESS_CHANGED, function (address) {
    dispatch('setAddress', address);
  });
  connector.on(common_1.ConnectorEvents.NETWORK_CHANGED, function (networkName) {
    logger.log('Network Changing to', networkName);
    dispatch('setNetworkByName', networkName);
  });
  connector.on(common_1.ConnectorEvents.CONNECTED, function (params) {
    logger.log('Updater witnessed connection');
    dispatch('connect', params);
  });
  connector.on(common_1.ConnectorEvents.WALLET_CHAIN_CHANGED, function (chainId) {
    logger.log("Wallet Chain Id is ".concat(chainId));
    dispatch('setWalletChainId', chainId);
  });
  connector.on(common_1.ConnectorEvents.DISCONNECTED, function () {
    logger.log('Updater witnessed disconnection');
    dispatch('disconnect');
  });
};
exports.updater = updater;
exports.default = exports.updater;